import { render } from "./Problem.vue?vue&type=template&id=12abd0c2&scoped=true&ts=true"
import script from "./Problem.ts?vue&type=script&lang=ts"
export * from "./Problem.ts?vue&type=script&lang=ts"

import "./Problem.scss?vue&type=style&index=0&id=12abd0c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12abd0c2"]])

export default __exports__